import { useState, useCallback } from 'react';
import useRangePlanningItemsApi from './useRangePlanningItemsApi';
import { RangePlanningItem } from '../types';

const useRangePlanningItemsList = () => {
  const { getItems } = useRangePlanningItemsApi();
  const [items, setItems] = useState<RangePlanningItem[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadItems = useCallback(async (search: string, category: string, page: number, pageSize: number) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getItems(search, category, page, pageSize);
      setItems(response.data);
      setTotalCount(response.totalCount);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load items');
      setItems([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  }, [getItems]);

  return { items, totalCount, isLoading, error, loadItems };
};

export default useRangePlanningItemsList;
